export default __webpack_public_path__ + "static/media/bh.ef7de265.svg";